import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { Channel } from '../../../../models/loyalty-channel.model';
import { LoyaltyChannelService } from '../../../../services/loyalty/loyalty-channel.service';
import { StoreCommonService } from '../../../../services/store/store-common.service';
import { LoyaltyAcmService } from 'app/services/loyalty/loyalty-acm.service';

@Component({
  selector: 'app-form-channel-loyalty',
  templateUrl: './form-channel-loyalty.component.html',
  styleUrls: ['./form-channel-loyalty.component.css']
})
export class FormChannelLoyaltyComponent implements OnInit {

  form: FormGroup;
  @Input() channelId: string;
  @Input() editMode: boolean;
  stores: { value: number, label: string }[];
  acmDropdownList: Array<{ label: string, value: any }> = [];

  public invalidSubmit: boolean;

  fields: any;

  constructor(
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private channelService: LoyaltyChannelService,
    private storeService: StoreCommonService,
    private acmService: LoyaltyAcmService,
  ) { }

  ngOnInit() {

    this.stores = sessionStorage.getItem('channelsStores') ? JSON.parse(sessionStorage.getItem('channelsStores')) : [{value: null, label: ''}];

    this.channelId = this.activatedRoute.snapshot.params['channelId'];
    this.editMode = (typeof this.channelId !== 'undefined');

    let channel: Observable<Channel>;

    if (!this.editMode) {
      channel = Observable.of(new Channel());
    } else {
      channel = this.channelService.get(this.channelId);
    }

    this.channelService.getFields().subscribe(res => {
      this.fields = res;
    });

    if (!sessionStorage.getItem('channelsStores')) {
      this.storeService.getList().subscribe(
        res => {
          for (const singleStore of res) {
            this.stores.push({
              label: singleStore.description,
              value: singleStore.id});
          }
        },
        error => console.error(error),
        () => sessionStorage.setItem('channelsStores', JSON.stringify(this.stores))
      );
    }

    // Carica lista completa ACM per la dropdown con filtro
    const acmParams = [{key: 'acmVisible', value: '0'}];
    this.acmService.getAllAcm(acmParams).subscribe(res => {
      this.acmDropdownList = [{label: '', value: null}].concat(
        res.map(function(acm) { return { label: acm.acm_code + ' - ' + acm.acmDescription, value: acm.id }; })
      );
    });

    Observable.zip(channel).subscribe(([resChannel]) => {

      this.form = this.fb.group({
        default_store_id: resChannel.default_store_id || null,
        description: resChannel.description || '',
        channel_code: resChannel.channel_code || '',
        default_acm: resChannel.default_acm_id || null
      });

    });

  }
  save() {
    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    const channel = new Channel();
    channel.description = this.form.get('description').value;
    channel.default_store_id = this.form.get('default_store_id').value;
    channel.channel_code = this.form.get('channel_code').value;
    channel.default_acm_id = this.form.get('default_acm').value;
    if (!this.editMode) {
      this.channelService.create(channel).subscribe(res => {
        this.router.navigate(['/loyalty/channel']);
      });
    }else {
      channel.id = this.channelId;
      this.channelService.update(channel).subscribe(res => {
        this.router.navigate(['/loyalty/channel']);
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-channel/form-channel-loyalty/form-channel-loyalty.component.ts